module.exports = __webpack_public_path__ + "static/media/icon-wechat-trans-selected.b30ba37e.svg";